import _ from 'underscore';
import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { noteCreationButtonConfig, openNotesPanelButtonConfig } from '@bingads-webui-campaign-react/note-editor';
import { getLocalStorage } from '@bingads-webui/storage';

/* global Map */
const automatedRuleConfig = ['dropdown-automate', {
  id: 'dropdown-automate',
  type: 'dropdown',
}];

export function getToolbarConfig({
  onSelectCrossPage,
  scope,
  i18n,
  siteMap,
  permissions,
  serverContext,
  notesPanelProps,
  noteDialogProps,
  instrumentation,
}) {
  const isCurrentAccountInActive = _.chain(serverContext).result('CurrentAccount').result('Status').value() === 32; // 32 is InActive
  const createScenario = instrumentation.newUICreateCampaignImportIntegration.create();
  const importIntegrationLogger = createScenario.importIntegration.create();

  importIntegrationLogger.trace('ShowMenuCreateCamapaign');

  // eslint-disable-next-line
  const toolbarSelectedConfig = _.reduce(
    [
      ['selection-widget', {
        type: 'selection-widget',
        onSelectCrossPage,
      }],
      ['divider', {
        type: 'divider',
      }],
      ['dropdown-edit', {
        id: 'dropdown-edit',
        type: 'dropdown',
      }],
      ['dropdown-labels', {
        id: 'dropdown-labels',
        type: 'dropdown',
      }],
      automatedRuleConfig,
      ['button-auction-insights', {
        type: 'button',
        isFallbackEnabled: false,
      }],
      ['button-create-note',
        permissions.IsNoteEnabled ? noteCreationButtonConfig(i18n, permissions, isCurrentAccountInActive, () => noteDialogProps.openCreateNoteDialog('Campaign')) : null,
      ],
      ['expander', {
        type: 'expander',
      }],
      ['button-clear-selection', {
        type: 'button-clear-selection',
      }],
      ['button-chart-toggle', {
        id: 'button-chart-toggle',
        type: 'button',
      }],
    ], (map, [key, value]) => {
      if (value != null) {
        map.set(key, value);
      }

      return map;
    },
    new Map()
  );

  const toolbarUnselectedItems = [
    ['button-campaign-create', {
      id: 'button-campaign-create',
      type: 'button',
      text: i18n.getString(_TL_('Create')),
      classes: ['btn-primary', 'btn'],
      iconLeftGlyphName: 'ba-Add',
      primary: true,
      split: true,
      splitButtonAriaLabel: i18n.getString(_TL_('See options')),
      'aria-roledescription': i18n.getString(_TL_('split button')),
      menuProps: permissions.IsDomesticSimplifiedChineseEnabled ? null : {
        items: [
          {
            key: 'googleImport',
            text: i18n.getString(_TL_('Import from Google Ads')),
            ariaLabel: i18n.getString(_TL_('Go to page Import from Google Ads')),
            className: 'import-from-google',
            onClick: () => {
              importIntegrationLogger.trace('ClickMenuImportFromGoogleAds');
              scope.save(getRoutePathById(siteMap, 'import-google'));
            },
          },
          ...permissions.dynamic.FacebookImport ? [{
            key: 'facebookImport',
            text: i18n.getString(_TL_('Import from Meta Ads')),
            ariaLabel: i18n.getString(_TL_('Go to page Import from Meta Ads')),
            className: 'import-from-facebook',
            onClick: () => {
              importIntegrationLogger.trace('ClickMenuImportFromFacebookAds');
              scope.save(getRoutePathById(siteMap, 'import-facebook'));
            },
          }] : [],
          ...permissions.IsAmazonImportEnabled ? [{
            key: 'amazonImport',
            text: i18n.getString(_TL_('Import from Amazon Ads')),
            ariaLabel: i18n.getString(_TL_('Go to page Import from Amazon Ads')),
            className: 'import-from-amazon',
            onClick: () => {
              importIntegrationLogger.trace('ClickMenuImportFromAmazonAds');
              scope.save(getRoutePathById(siteMap, 'import-amazon'));
            },
          }] : [],
          {
            key: 'pinterestImport',
            text: i18n.getString(_TL_('Import from Pinterest Ads')),
            ariaLabel: i18n.getString(_TL_('Go to page Import from Pinterest Ads')),
            className: 'import-from-pinterest',
            onClick: () => {
              importIntegrationLogger.trace('ClickMenuImportFromPinterestAds');
              scope.save(getRoutePathById(siteMap, 'import-pinterest'));
            },
          },
        ],
      },
      noResponsive: true,
      disabled: permissions.IsReadOnlyUser || isCurrentAccountInActive,
      onClick: () => {
        importIntegrationLogger.trace('ClickMenuCreateCamapaign');
        scope.save(getRoutePathById(siteMap, 'campaign-create-objective'));
        const localStorage = getLocalStorage();
        if (localStorage.supportsStorage()) {
          localStorage.set('fromPathId', 'campaigns');
        }
      },
    }],
    ['predicate-list', {
      id: 'predicate-list',
      type: 'custom',
    }],
    ['search-box-filter', {
      id: 'search-box-filter',
      type: 'search-box',
      isAdvancedFilterEnabled: true,
      isCustomItemRenderingEnabled: _.result(permissions.dynamic, 'AdGroupsPageAdvancedFiltering', false),
      ariaLabel: i18n.getString(_TL_('Filter by campaign')),
      entityName: i18n.getString(_TL_('campaigns')),
    }],
    ['dropdown-segment', {
      id: 'dropdown-segment',
      type: 'dropdown',
    }],
    ['dropdown-column-chooser', {
      id: 'dropdown-column-chooser',
      type: 'dropdown',
      ariaLabel: i18n.getString(_TL_('Columns')),
    }],
    automatedRuleConfig,
    ['button-download', {
      id: 'button-download',
      type: 'nav-item',
      iconLeftGlyphName: 'ba-Download',
      ariaLabel: i18n.getString(_TL_('Download')),
    }],
  ];

  if (permissions.IsCampaignAdGroupCopyPasteEnabled) {
    toolbarUnselectedItems.push(['button-paste', {
      id: 'button-paste',
      type: 'nav-item',
      iconLeftGlyphName: 'ba-Paste',
    }]);
  }

  if (permissions.IsNoteEnabled) {
    toolbarUnselectedItems.push(['button-open-note-panel', openNotesPanelButtonConfig(i18n, notesPanelProps.openNotesPanel)]);
  }
  toolbarUnselectedItems.push(
    ['expand-table', {
      type: 'expand-table',
    }],
    ['divider', {
      type: 'divider',
    }],
    ['button-chart-toggle', {
      id: 'button-chart-toggle',
      type: 'button',
    }]
  );

  // eslint-disable-next-line
  const toolbarUnselectedConfig = _.reduce(
    toolbarUnselectedItems,
    (map, [key, value]) => {
      map.set(key, value);
      return map;
    },
    new Map()
  );
  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}
